import { render } from "./PlayerDetailView.vue?vue&type=template&id=1ce58fc8"
import script from "./PlayerDetailView.vue?vue&type=script&lang=js"
export * from "./PlayerDetailView.vue?vue&type=script&lang=js"

import "./PlayerDetailView.vue?vue&type=style&index=0&id=1ce58fc8&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__